import { BreadcrumbItemProps } from '../Breadcrumbs/BreadcrumbItem';

import FirstItemIcon from './components/FirstItemIcon';

export const renderItemWrapper = (isDropdownList: boolean, renderItem: Function) => (props: BreadcrumbItemProps) =>
  props.isFirst && !isDropdownList && !props.isLast ? (
    <FirstItemIcon>{renderItem(props)}</FirstItemIcon>
  ) : (
    renderItem(props)
  );
